import React from "react";
import { Link } from "react-router-dom";
import soloTravelerBg from "../../Assests/images/solo-traveler-bg.jpg";

function SoloTravelersV1() {
  return (
    <section
      className="v1-solo-section"
      style={{ backgroundImage: `url(${soloTravelerBg})` }}
    >
      <div className="v1-solo-overlay"></div>

      <div className="v1-solo-container">
        {/* Top Content Box */}
        <div className="v1-solo-top-box">
          {/* Tagline Container */}
          <div className="v1-solo-tag-container">
            <span className="v1-solo-tag">TRAVEL SOLO · MEET PEOPLE · MAKE MEMORIES</span>
          </div>

          {/* Heading 2 */}
          <div className="v1-solo-heading-container">
            <h2 className="v1-solo-heading">
              Solo Travelers,<br />A Bigger World Awaits
            </h2>
          </div>

          {/* Description Container */}
          <div className="v1-solo-desc-container">
            <p className="v1-solo-desc">
              Join a community of like-minded explorers and discover experiences designed for solo adventurers.
            </p>
          </div>

          {/* Link Button */}
          <Link to="/experiences" className="v1-solo-btn">
            <span>Explore Solo Experiences</span>
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#111A2E"
              strokeWidth="2.33"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="5" y1="12" x2="19" y2="12" />
              <polyline points="12 5 19 12 12 19" />
            </svg>
          </Link>
        </div>

        {/* Bottom Feature List (3 cards, height: 94px, gap: 16px) */}
        <div className="v1-solo-list">
          {/* Card 1 */}
          <div className="v1-solo-card">
            <div className="v1-solo-icon-bubble">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#111A2E" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
              </svg>
            </div>
            <div className="v1-solo-card-info">
              <span className="v1-solo-card-title">Meet</span>
              <span className="v1-solo-card-subtitle">Like-Minded People</span>
            </div>
          </div>

          {/* Card 2 */}
          <div className="v1-solo-card">
            <div className="v1-solo-icon-bubble">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#111A2E" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6" />
                <line x1="8" y1="2" x2="8" y2="18" />
                <line x1="16" y1="6" x2="16" y2="22" />
              </svg>
            </div>
            <div className="v1-solo-card-info">
              <span className="v1-solo-card-title">Curated</span>
              <span className="v1-solo-card-subtitle">Solo-Friendly Tours</span>
            </div>
          </div>

          {/* Card 3 */}
          <div className="v1-solo-card">
            <div className="v1-solo-icon-bubble">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#111A2E" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                <polyline points="9 12 11 14 15 10" />
              </svg>
            </div>
            <div className="v1-solo-card-info">
              <span className="v1-solo-card-title">Safe &amp; Supportive</span>
              <span className="v1-solo-card-subtitle">Travel</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SoloTravelersV1;
